import { useSelector, useDispatch } from 'react-redux'
import { rateSelector, lastBookingBasketItemSelector, waitingListKeySelector } from 'booking/selectors'
import { makePurchase } from 'basket/actions'
import useBookingValidation from './useBookingValidation'

const useOnPayForParking = () => {
    const rate = useSelector(rateSelector)
    const dispatch = useDispatch()
    const { validateBooking } = useBookingValidation()
    const waitingListKey = useSelector(waitingListKeySelector)
    const lastBookingBasketItem = useSelector(lastBookingBasketItemSelector)

    const onPayForParkingClick = (
        inboundNumber,
        outboundNumber,
        additionalServices,
        guestUserPersonalData,
        reservationId
    ) => {
        if (!validateBooking({ purchaseValidation: true })) return
        if (rate?.isOnWaitingList && !waitingListKey) return

        window.grecaptcha.ready(() => {
            window.grecaptcha.execute(GOOGLE_RECAPTCHA_KEY, { action: 'submit' }).then(token => {
                dispatch(
                    makePurchase(
                        lastBookingBasketItem,
                        token,
                        inboundNumber,
                        outboundNumber,
                        additionalServices,
                        guestUserPersonalData,
                        reservationId
                    )
                )
            })
        })
    }

    return { onPayForParkingClick }
}

export default useOnPayForParking
